import * as React from "react";
import TextField from "@mui/material/TextField";
import { Autocomplete, useTheme } from "@mui/material";
import { LISTA_SEXOS } from "../../constants";

type Props = {
  setSexo: (p: string) => void;
};

const SexoField: React.FC<Props> = (props) => {
  const { setSexo } = props;

  const theme = useTheme();

  // Defina o valor de xs com base nos breakpoints do tema
  const xsValue = theme.breakpoints.down("sm") ? 12 : 6;

  return (
    <div style={{ textAlign: "center" }}>
      <Autocomplete
        id="filter-sexo"
        options={LISTA_SEXOS}
        getOptionLabel={(option) => option.decricao}
        onChange={(event, value) => {
          if (value) setSexo(value.decricao);
        }}
        sx={{ xsValue }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant={"outlined"}
            label={"Gênero"}
            placeholder={"Gênero"}
            multiline={true}
          />
        )}
      />
    </div>
  );
};

export default SexoField;
